__turbopack_context__.v({
  "className": "inter_f5d5c5a8-module__dkD2tG__className",
  "variable": "inter_f5d5c5a8-module__dkD2tG__variable",
});
